import React from "react";
import style from "./contact.module.css";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";

export default function Contact() {
  return (
    <div className={style.container} id="Contact">
      <h1>Contact</h1>
      <div className={style.linksBox}>
        <a
          href="https://www.linkedin.com/in/pedro-mu%C3%B1oz-bedoya-70b5891a3"
          className={style.linkBox}
        >
          <LinkedInIcon sx={{ fontSize: 40 }} />
          <p>Pedro Munoz</p>
        </a>
        <a href="https://github.com/SrDevDash" className={style.linkBox}>
          <GitHubIcon sx={{ fontSize: 40 }} />
          <p>SrDevDash</p>
        </a>
      </div>
    </div>
  );
}
